/**
 * Formats a price string into a float number by:
 * - Removing any non-numeric characters
 * - Replacing commas with periods
 * - Parsing into a float
 *
 * @param {string} value - The input price string
 * @returns {number} The formatted price as a float
 */
export const getFormattedPrice = (value) => {
  let justNumber = value.replace(/[^\d,]/g, "");
  let formattedNumber = justNumber.replace(",", ".");
  let finalPrice = parseFloat(formattedNumber);

  return finalPrice;
};
